import React, { Component, useEffect, useState } from "react";
import styled from "styled-components";
import NeoInsuranceLogo from "../../assets/svgs/neoInsuranceLogoWhite_risk.svg";
import VitalLogo from "../../assets/images/vitalLogoCopy.png";
import { Ptag } from "../fonts";
import { useHistory, useLocation } from "react-router-dom";
import http from "../../services/httpService";
import popupcrossbutton from "../../assets/images/popupcrossbutton.png";
import { useMemo } from "react";
import { colors, theme } from "../../theme";
import LoaderDots from "../loaderDots";
const EmployerDesktop = (Component) => {
  const { pathname } = useLocation();
  const currentRoute = pathname && pathname.replace("/", "");
  const isEmployerDashboardNew = [
    "business/employee-registration-dashboard",
  ].includes(currentRoute);

  return () => {
    const [loader, setLoader] = useState(true);
    const [company_name, setCompanyName] = useState("");
    const [addEmp, setAddEmp] = useState(false);
    const [renderAddEmp, setRenderAddEmp] = useState(false);
    const [addEmpNoti, setAddEmpNoti] = useState("");
    const [sboType, setSboType] = useState("");
    const [buffer, setBuffer] = useState(
      JSON.parse(localStorage.getItem("corporateBufferExist"))
    );
    const local_details = localStorage.getItem("gmc_details");

    const history = useHistory();

    useEffect(() => {
      (async function() {
        setLoader(true);
        const corpBufferExist = localStorage.getItem("corporateBufferExist");
        const companyName = localStorage.getItem("companyName");
        if (!corpBufferExist || !companyName) {
          await checkCorporateBuffer();
        } else {
          setCompanyName(companyName);
        }
        setLoader(false);
      })();
    }, [local_details]);

    const checkCorporateBuffer = async () => {
      try {
        const { data } = await http.get(
          "/business/get_company_product_details/"
        );
        const products = Object.keys(data.product_details);
        let doesGmcExist = products.includes("health_insurance");
        let corporateBufferExist = false;
        if (doesGmcExist) {
          corporateBufferExist =
            data.product_details["health_insurance"].is_corporatebuffer;
        }
        localStorage.setItem("corporateBufferExist", corporateBufferExist);
        localStorage.setItem("companyName", data.company_name);
        setBuffer(corporateBufferExist);
        setCompanyName(data.company_name || "");
      } catch (e) {
        console.log(e);
      }
    };

    const universalCompamyName = useMemo(() => {
      return (
        // (localStorage.getItem("user_plan_details") &&
        //   JSON.parse(localStorage.getItem("user_plan_details")).company_name) ||
        company_name && company_name
      );
    }, [company_name]);

    const goToPayments = () => {
      if (localStorage.getItem("employee_details")) {
        history.push("/business/paymentsummary");
      }
    };
    const goToGmcPayments = () => {
      history.push("/business/gmcpaymentsummary");
    };

    const goToEnrolmentHistory = () => {
      history.push("/business/enrolment-history");
    };

    const gotToEndorsementHistory = () => {
      history.push("/business/endorsement-history");
    };

    const goToDataCollectionHistory = () => {
      history.push("/business/data-collection-history");
    };

    const goToCd = () => {
      history.push("/business/view_cd_balance");
    };

    const goToDashboard = () => {
      history.push("/business/dashboard");
    };

    const goToCb = () => {
      history.push("/business/view-buffer-amount");
    };

    const addEmployess = () => {
      if (addEmp === true) {
        setRenderAddEmp(true);
      } else {
        history.push("/business/uploadExcel");
      }
    };

    const logout = () => {
      localStorage.clear();
      history.push("/business/phone");
      // window.location.href = '/group-health-plan/' removed because landing pages are not working now
    };

    const changeRenderAddEmp = () => {
      setRenderAddEmp(false);
    };

    const isGmc = useMemo(() => {
      let sb = sboType;
      if (sessionStorage.getItem("sboType"))
        sb = sessionStorage.getItem("sboType");
      return (
        sb === "GMC" ||
        sb === "GMC_M" ||
        sb === "GPA" ||
        sb === "GTL" ||
        localStorage.getItem("isFlex")
      );
    }, [sboType]);

    const flow = localStorage.getItem("flow");

    return (
      <Home>
        <HomeWrapperLeft>
          <LogoWrapper onClick={goToDashboard}>
            <img src={NeoInsuranceLogo} />
          </LogoWrapper>
          <LogoBorder />

          {loader ? (
            <div
              style={{
                display: "flex",
                height: "100vh",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <LoaderDots />
            </div>
          ) : (
            <MenuBox>
              {!isEmployerDashboardNew && (
                <>
                  <Box onClick={goToDashboard}>
                    <Ptag
                      color={
                        currentRoute.indexOf("dashboard") > -1
                          ? "#fff"
                          : "#cacaca"
                      }
                      fontWeight="500"
                      fontSize="18px"
                      letterSpacing="0.6px"
                    >
                      Overview
                    </Ptag>
                  </Box>
                  {!!buffer && (
                    <Box onClick={goToCb}>
                      <Ptag
                        color={
                          currentRoute.indexOf("buffer") > -1
                            ? "#fff"
                            : "#cacaca"
                        }
                        fontWeight="500"
                        fontSize="18px"
                        letterSpacing="0.6px"
                      >
                        View Corporate Buffer
                      </Ptag>
                    </Box>
                  )}
                  <Box onClick={goToCd}>
                    <Ptag
                      color={
                        currentRoute.indexOf("cd") > -1 ? "#fff" : "#cacaca"
                      }
                      fontWeight="500"
                      fontSize="18px"
                      letterSpacing="0.6px"
                    >
                      View CD Account
                    </Ptag>
                  </Box>
                  {/* {isGmc && (
                  <Box onClick={goToEnrolmentHistory}>
                    <Ptag
                      color={
                        currentRoute.indexOf("enrolment") > -1
                          ? "#fff"
                          : "#cacaca"
                      }
                      fontWeight="500"
                      fontSize="18px"
                      letterSpacing="0.6px"
                    >
                      Enrolment History
                    </Ptag>
                  </Box>
                )} */}
                  <Box onClick={gotToEndorsementHistory}>
                    <Ptag
                      color={
                        currentRoute.indexOf("endorsement-history") > -1
                          ? "#fff"
                          : "#cacaca"
                      }
                      fontWeight="500"
                      fontSize="18px"
                      letterSpacing="0.6px"
                    >
                      View Enrolment History
                    </Ptag>
                  </Box>

                  <Box onClick={goToDataCollectionHistory}>
                    <Ptag
                      color={
                        currentRoute.indexOf("data-collection-history") > -1
                          ? "#fff"
                          : "#cacaca"
                      }
                      fontWeight="500"
                      fontSize="18px"
                      letterSpacing="0.6px"
                    >
                      Data Collection History
                    </Ptag>
                  </Box>

                  {/* {!isGmc && (
                  <Box onClick={goToPayments}>
                    <Ptag
                      color={
                        currentRoute.indexOf("paymentsummary") > -1
                          ? "#fff"
                          : "#cacaca"
                      }
                      fontWeight="500"
                      fontSize="18px"
                      letterSpacing="0.6px"
                    >
                      Payments
                    </Ptag>
                  </Box>
                )}
                {isGmc && (
                  <Box onClick={goToGmcPayments}>
                    <Ptag
                      color={
                        currentRoute.indexOf("gmcpaymentsummary") > -1
                          ? "#fff"
                          : "#cacaca"
                      }
                      fontWeight="500"
                      fontSize="18px"
                      letterSpacing="0.6px"
                    >
                      Payments
                    </Ptag>
                  </Box>
                )} */}

                  {/* {
                                    !isGmc &&
                                    <Box onClick={addEmployess} >
                                        <Ptag color={currentRoute.indexOf('uploadExcel') > -1 ? '#fff' : '#cacaca'} fontWeight='500' fontSize='18px' letterSpacing='0.6px'>Add Employees</Ptag>
                                    </Box>
                                } */}
                </>
              )}

              <Box onClick={logout}>
                <Ptag
                  color={"#cacaca"}
                  fontWeight="600"
                  fontSize="18px"
                  letterSpacing="0.6px"
                >
                  Logout
                </Ptag>
              </Box>
              {/* <Ptag marginTop="54px" fontSize='14px'>Profile</Ptag> */}
            </MenuBox>
          )}
        </HomeWrapperLeft>
        <HomeWrapperRight>
          {renderAddEmp && (
            <UploadExcelPopUpDiv>
              <Innerpopup>
                <SubInnerDiv>
                  <FirstRow>
                    <Ptag fontSize="22px" fontWeight="bold">
                      {addEmpNoti}
                    </Ptag>
                    <CrossButton onClick={changeRenderAddEmp}>
                      <img
                        style={{ cursor: "pointer" }}
                        src={popupcrossbutton}
                        width="24px"
                        height="24px"
                      />
                    </CrossButton>
                  </FirstRow>
                  <SecondSubRow></SecondSubRow>
                </SubInnerDiv>
              </Innerpopup>
            </UploadExcelPopUpDiv>
          )}
          <UpperHomeWrapperRight>
            <MainDiv>
              <WelcomeLeft>
                <Ptag
                  fontSize="32px"
                  fontWeight="600"
                  fontFamily="Merriweather"
                  letterSpacing="0.6px"
                  letterHeight="1.13"
                  marginBottom="1rem"
                  textTransform="capitalize"
                >
                  {company_name && company_name.toLowerCase()}
                </Ptag>
                {/* <Ptag fontSize="14px" marginTop="12px" letterSpacing="0.58px">
                  Welcome to Neo Risk & Insurance Brokers
                </Ptag> */}
              </WelcomeLeft>
            </MainDiv>
          </UpperHomeWrapperRight>
          <Component />
        </HomeWrapperRight>
      </Home>
    );
  };
};

export default EmployerDesktop;

const Home = styled.div`
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
`;
const HomeWrapperLeft = styled.div`
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #221b3c, #440e69);
  position: fixed;
  width: 20%;
  padding-top: 4.4rem;
  height: 100%;
  box-sizing: border-box;
  /* padding: 4.4rem 4.4rem 2.4rem 2.4rem; */
  transition: width 0.2s ease-in;
`;
const Innerpopup = styled.div`
  position: absolute;
  left: 25%;
  right: 25%;
  top: 5%;
  bottom: 5%;
  margin: auto;
`;
const SubInnerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 50px 190px 50px;
  background: #ffffff;
  border-radius: 10px;
`;
const FirstRow = styled.div`
  justify-content: space-between;
  display: flex;
`;
const CrossButton = styled.p``;
const UploadExcelPopUpDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1200;
`;

const SecondSubRow = styled.div`
  padding-top: 10px;
`;

const MenuBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 6rem;
`;

const Box = styled.div`
  cursor: pointer;
  padding: 20px 5rem;
  text-decoration: none;
  transition: 0.2s ease-in-out all;
  &:hover {
    background-color: #ad9aff3b;
  }
  & p {
    transition: 0.2s ease-in-out all;
  }
  &:hover p {
    transform: translateX(7px);
  }
`;

const LogoWrapper = styled.div`
  width: 100%;
  margin-top: 3rem;
  text-align: center;
  & > img {
    width: 200px;
    max-width: 240px;
    margin-bottom: 1rem;
  }
  cursor: pointer;
`;

const HomeWrapperRight = styled.div`
  margin-left: 20%;
  width: 80%;
  height: 100%;
  /* overflow:scroll; */
  display: flex;
  flex-direction: column;
  background-color: #dbdbdb;
`;

const UpperHomeWrapperRight = styled.div`
  width: 100%;
  transition: margin-left 0.2s ease-in;
  padding: 48px 40px 18px 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px;
  margin-bottom: 12px;
`;

const MainDiv = styled.div`
  display: flex;
  text-align: left;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #436ab2;
  justify-content: space-between;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
`;

const WelcomeLeft = styled.div`
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: 0.6px;
  color: #436ab2;
`;

const LogoBorder = styled.div`
  margin: 0 auto;
  width: 70%;
  height: 1px;
  margin-top: 1rem;
  background-color: #e5f7ff;
  opacity: 0.7;
`;
